import React from "react";
import "./Profile.css";
import { User, School, Calendar, Home, Phone } from "lucide-react";

export default function ProfilePage() {
  const student = {
    name: "Jianshi Sandeep Majethia",
    standard: "3rd",
    school: "Ryewood international School ",
    age: 8,
    address:
      "C202, Gulmohar Building, Sanghvi Nisarg Society, Khondgewadi, Lonavala 410401",
    phone: "8928887200",
  };

  return (
    <div className="profile-container">
      <h1 className="profile-title">Student Profile</h1>
      <div className="profile-details">
        <div className="profile-item">
          <User className="profile-icon" />
          <span className="profile-label">Student Name:</span>
          <span className="profile-value">{student.name}</span>
        </div>
        <div className="profile-item">
          <School className="profile-icon" />
          <span className="profile-label">Standard:</span>
          <span className="profile-value">{student.standard}</span>
        </div>
        <div className="profile-item">
          <School className="profile-icon" />
          <span className="profile-label">School Name:</span>
          <span className="profile-value">{student.school}</span>
        </div>
        <div className="profile-item">
          <Calendar className="profile-icon" />
          <span className="profile-label">Age:</span>
          <span className="profile-value">{student.age} years</span>
        </div>
        <div className="profile-item">
          <Home className="profile-icon" />
          <span className="profile-label">Address:</span>
          <span className="profile-value">{student.address}</span>
        </div>
        <div className="profile-item">
          <Phone className="profile-icon" />
          <span className="profile-label">Phone No:</span>
          <span className="profile-value">{student.phone}</span>
        </div>
      </div>
    </div>
  );
}
